import { render, staticRenderFns } from "./groupon.vue?vue&type=template&id=71b8d81a&scoped=true&"
import script from "./groupon.vue?vue&type=script&lang=js&"
export * from "./groupon.vue?vue&type=script&lang=js&"
import style0 from "./groupon.vue?vue&type=style&index=0&id=71b8d81a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8d81a",
  null
  
)

export default component.exports